import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoadingWrapper } from 'barnyard/components';
import { vendorFetch, profileFetch } from './actions';
import { getProfile, getVendor } from '~/accounts/signup/selectors';
import {
  USER_FORM_URL,
  VENDOR_FORM_URL,
  FINISHED_URL,
} from './constants';

/*
  Rendered for every component in the Signup app. Will handle the initial fetching of
  profile and necessary form content

  Also will be responsible for redirecting to URLs when necessary
*/

class Root extends Component {
  componentDidMount() {
    const {
      vendorFetchAction,
      profileFetchAction,
    } = this.props;

    profileFetchAction();
    vendorFetchAction();
  }

  componentDidUpdate(prevProps) {
    const { profile: prevProfile, vendor: prevVendor } = prevProps;
    const {
      profile,
      vendor,
      router,
      location
    } = this.props;

    const wasLoadingProfile = prevProfile.isLoading === true && profile.isLoading === false;
    const wasLoadingVendor = prevVendor.isLoading === true && prevVendor.isLoading === false;
    const hasStoppingQueryParam = location.query.redirect === 'false';

    if (hasStoppingQueryParam || (!wasLoadingProfile && !wasLoadingVendor)) {
      if (vendor.isFetched && profile.isFetched && vendor.has_completed_signup) {
        window.location = location.query.next || FINISHED_URL;
      }
      return;
    }

    if (prevProfile.isError === false && profile.isError === true) {
      return router.replace({
        pathname: USER_FORM_URL,
        search: location.search
      });
    }

    if (prevVendor.isError === false && vendor.isError === true) {
      return router.replace({
        pathname: VENDOR_FORM_URL,
        search: location.search
      });
    }

    if (profile.isFetched) {
      // Check that they submitted updated vendor info
      if (!wasLoadingVendor && !vendor.has_completed_signup) {
        return router.replace({
          pathname: VENDOR_FORM_URL,
          search: location.search
        });
      }
    }
  }

  render() {
    const {
      profile,
      vendor,
      location
    } = this.props;

    const isLoading = location.query.redirect !== 'false' && (
      profile.isFetched && vendor.has_completed_signup
    );

    return (
      <LoadingWrapper loading={isLoading}>
        {this.props.children}
      </LoadingWrapper>
    );
  }
}

Root.propTypes = {
  children: PropTypes.node.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  vendor: PropTypes.object.isRequired,
  profileFetchAction: PropTypes.func.isRequired,
  vendorFetchAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  vendor: getVendor(state),
  profile: getProfile(state),
});

const mapDispatchToProps = dispatch => ({
  vendorFetchAction: () => dispatch(vendorFetch()),
  profileFetchAction: () => dispatch(profileFetch())
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
